import { UserModel } from '../../../../app/modules/auth/models/UserModel'
import { RootState } from '../../../../setup/redux/RootReducer'
import { shallowEqual, useSelector } from 'react-redux'
import { hasRole } from '../../../../app/utils/permissions'
import { UserRole } from '../../../../app/constants/roles'
import { MenuFinalUser } from './menus/MenuFinalUser'
import { MenuAdmin } from './menus/MenuAdmin'
import { MenuPartner } from './menus/MenuPartner'
import { MenuTeam } from './menus/MenuTeam'
import { getVersionInfo } from '../../../../app/utils/constants'
import { useState } from 'react'
import { ChangelogModal } from '../../../../app/helpers/ChangelogModal'

export function AsideMenuMain() {
  const user = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const version = getVersionInfo()
  const [show,setShow] = useState<boolean>(false)

  // Armando 2026-09-10: FINAL_USER siempre gana. Si el user tiene multiples roles
  // (ej. members que ademas son PARTNER o TEAM tras el bridge de expertise PR-I-86),
  // el aside renderizaba dos/tres menus apilados (MY ACCOUNT + MEMBERS ACCOUNT + ...).
  // Regla: cuando FINAL_USER esta presente, ese es el menu canonico y ocultamos los demas;
  // solo si el user NO es FINAL_USER caemos a los otros roles (admin puro, partner puro,
  // team puro). Las secciones especificas de partner/team siguen accesibles via rutas
  // directas (/my-expertise, /expert-search, etc.) sin necesidad del sidebar duplicado.
  const isFinalUser = hasRole(user, UserRole.FINAL_USER)

  return (
    <div className='nb-aside-menu'>
      {isFinalUser && <MenuFinalUser />}
      {!isFinalUser && (hasRole(user,UserRole.ADMIN) || hasRole(user,UserRole.STAFF_USER)) && <MenuAdmin />}
      {!isFinalUser && hasRole(user,UserRole.PARTNER) && <MenuPartner />}
      {!isFinalUser && hasRole(user,UserRole.TEAM) && <MenuTeam />}
      <div className='card-environments cursor-pointer' onClick={()=>setShow(true)}>
        <div className={`card-environments-content card-environments__${version.environment}`}>
          <div className='card-environments-info'>
            <div className='card-environments-name'>{version.environment}</div>
          </div>
          <div className='card-environments-availability'>
            <span>
              version: {version.version}<br />
              updated: {version.updatedAt}<br />
            </span>
          </div>
        </div>
      </div>
      <ChangelogModal show={show} onHide={()=>setShow(false)} version={version} />
    </div>
  )
}